// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/bookmark.js';

import { paths } from '../generated/bookmark';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('bookmark', Original, paths);
